import { Link } from "react-router-dom";
import { TopNav } from "./components/TopNav";
import "./sportSelector.css";

import indexRunning from "./img/index/indexRunning.jpg";
import indexSwimming from "./img/index/indexSwimming.jpg";
import indexCycling from "./img/index/indexCycling.jpg";
import indexHyrox from "./img/index/indexHyrox.jpg";
import indexTriathlon from "./img/index/indexTriathlon.jpg";

const Index = () => {
  const sports = [
    {
      name: "Running",
      path: "/running",
      description: "5K, 10K, Half Marathon, Marathon",
      image: indexRunning,
    },
    {
      name: "Swimming",
      path: "/swimming",
      description: "50m, 100m, 400m, 1500m, 5km, 10km",
      image: indexSwimming,
    },
    {
      name: "Cycling",
      path: "/cycling",
      description: "20km, 40km, 80km, 100km, 160km",
      image: indexCycling,
    },
    {
      name: "Hyrox",
      path: "/hyrox",
      description: "Women/Men Open & Pro",
      image: indexHyrox,
    },
    {
      name: "Triathlon",
      path: "/triathlon",
      description: "Sprint, Standard, Half Ironman, Ironman",
      image: indexTriathlon,
    },
  ];

  return (
    <div className="index-container">
      <TopNav active="home" />
      
      <div className="index-content">
        <div className="index-hero">
          <h1 className="index-title">Choose Your Sport</h1>
          <p className="index-subtitle">
            Select a sport to create your personalized training plan
          </p>
        </div>

        <div className="sport-grid">
          {sports.map((sport) => (
            <Link
              key={sport.path}
              to={sport.path}
              className="sport-card"
            >
              <div className="sport-image" aria-hidden="true">
                <img src={sport.image} alt="" loading="lazy" />
              </div>
              <div className="sport-info">
                <h2 className="sport-name">{sport.name}</h2>
                <p className="sport-description">{sport.description}</p>
              </div>
              <div className="sport-arrow">→</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Index;
